// App.js
import React from 'react';
import "./App.css";
import { HashRouter } from "react-router-dom";
import Main from "./containers/Main";
import { ThemeProvider } from 'styled-components';
import { useDarkMode } from './components/footer/useDarkMode';
import { blueTheme, darkTheme } from './theme';
import { GlobalStyles } from './global';
import Toggle from './components/footer/Toggle';
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";

function App() {
  console.log("starting");
  const [theme, toggleTheme, componentMounted] = useDarkMode();

  const themeMode = theme === 'light' ? blueTheme : darkTheme;
  console.log(themeMode);


  if (!componentMounted) {
    return <div />
  };


  return (
    <ThemeProvider theme={themeMode}>
      <>
        <GlobalStyles />
        <HashRouter basename="/">
          <div>
            <Header theme={themeMode} />
            <Main theme={themeMode} />
          </div>
        </HashRouter>
        <Toggle theme={theme} toggleTheme={toggleTheme} />
        <Footer theme={themeMode} />
      </>
    </ThemeProvider>
  );
}

export default App;
